const doc = [({"zh_tw":({"adminConstantHotelCheckInAnswererType":({"guest":"顧客", "hotel":"機構"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;